import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { IcClipboard, IcPlus, IcEdit, IcFileAlt, IcUsers } from "../../Icons";
import axios from "axios";
import {
  Button, Table, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Row, Col,
} from "reactstrap";
import Header from "../../layout/Header/Header";
import Swal from "sweetalert2";

const VACIO = { nombre_comercial: "", contacto: "", telefono: "", email: "", observaciones: "" };

const fmt = (v) =>
  new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(Number(v) || 0);

function ListadoClientes() {
  const { user } = useContext(AuthContext);
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const auth = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };

  const [clientes, setClientes] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [modal, setModal] = useState(false);
  const [idEdit, setIdEdit] = useState("");
  const [form, setForm] = useState(VACIO);
  const [validaBoton, setValidaBoton] = useState(true);

  const toggle = () => setModal(!modal);
  const set = (campo) => (e) => setForm({ ...form, [campo]: e.target.value });

  useEffect(() => {
    axios.get(URL_CLIENTES, auth)
      .then((response) => setClientes(response.data))
      .catch(() => {});
  }, []); // eslint-disable-line

  function abrirNuevo() { setIdEdit(""); setForm(VACIO); toggle(); }
  function abrirEdit(a) {
    setIdEdit(a._id);
    setForm({
      nombre_comercial: a.nombre_comercial || "", contacto: a.contacto || "",
      telefono: a.telefono || "", email: a.email || "", observaciones: a.observaciones || "",
    });
    toggle();
  }

  function guardar(event) {
    event.preventDefault();
    if (!form.nombre_comercial) {
      Swal.fire("Falta información", "El nombre es obligatorio", "warning");
      return;
    }
    setValidaBoton(false);

    const peticion = idEdit
      ? axios.patch(`${URL_CLIENTES}/${idEdit}`, form, auth)
      : axios.post(URL_CLIENTES, form, auth);

    peticion
      .then(() => {
        axios.post(URL_LOGS, {
          tipo: idEdit ? "Editar Cliente" : "Crear Cliente",
          detalle: form.nombre_comercial, user: user.id,
        }, auth);
        setValidaBoton(true);
        toggle();
        Swal.fire("¡Listo!", idEdit ? "Cliente actualizado" : "Cliente creado", "success");
        setTimeout(() => window.location.reload(), 1000);
      })
      .catch((error) => {
        setValidaBoton(true);
        Swal.fire({
          icon: "error", title: "Oops...", text: "Something went wrong!",
          footer: `${error.response?.data?.message || ""}`,
        });
      });
  }

  const filtrados = clientes
    .filter((a) => a.is_active === "Si")
    .filter((a) =>
      busqueda === "" ||
      (a.nombre_comercial || "").toLowerCase().includes(busqueda.toLowerCase()) ||
      (a.contacto || "").toLowerCase().includes(busqueda.toLowerCase())
    )
    .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1));

  const totalSaldo = filtrados.reduce((s, a) => s + (a.saldo || 0), 0);

  return (
    <>
      <Header />
      {user.menu_clientes ? (
        <div className="card container col-12">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <IcUsers style={{ marginRight: 8, color: "#3b82f6" }} />
                Clientes
              </h3>
              <p className="page-subtitle">Saldos a favor del cliente, en pesos</p>
            </div>
            <div className="page-actions">
              <Button color="success" size="sm" onClick={abrirNuevo}>
                <IcPlus style={{ marginRight: 6 }} />
                Nuevo Cliente
              </Button>
            </div>
          </div>

          <div className="filter-bar">
            <Input
              bsSize="sm"
              type="text"
              placeholder="Buscar cliente..."
              value={busqueda}
              onChange={(e) => setBusqueda(e.target.value)}
              style={{ maxWidth: 280 }}
            />
          </div>

          <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
            <thead>
              <tr>
                <th>Cliente</th>
                <th>Contacto</th>
                <th>Teléfono</th>
                <th style={{ textAlign: "right" }}>Entradas</th>
                <th style={{ textAlign: "right" }}>Comisiones</th>
                <th style={{ textAlign: "right" }}>Salidas</th>
                <th style={{ textAlign: "right" }}>Saldo</th>
                <th>Edo. Cuenta</th>
                <th>Editar</th>
              </tr>
            </thead>
            <tbody>
              {filtrados.map((a) => (
                <tr key={a._id}>
                  <td>{a.nombre_comercial}</td>
                  <td>{a.contacto}</td>
                  <td>{a.telefono}</td>
                  <td style={{ textAlign: "right" }}>{fmt(a.entradas)}</td>
                  <td style={{ textAlign: "right" }}>{fmt(a.comisiones)}</td>
                  <td style={{ textAlign: "right" }}>{fmt(a.salidas)}</td>
                  <td style={{ textAlign: "right", fontWeight: 700,
                               color: (a.saldo || 0) > 0 ? "#059669" : "#0f172a" }}>
                    {fmt(a.saldo)}
                  </td>
                  <td>
                    <Button color="primary" size="sm" href={`/EstadoCuenta?cliente=${a._id}`}>
                      <IcFileAlt />
                    </Button>
                  </td>
                  <td>
                    <Button color="info" size="sm" onClick={() => abrirEdit(a)}>
                      <IcEdit />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={6} style={{ textAlign: "right", fontWeight: 700 }}>Total</td>
                <td style={{ textAlign: "right", fontWeight: 700 }}>{fmt(totalSaldo)}</td>
                <td colSpan={2}></td>
              </tr>
            </tfoot>
          </Table>
        </div>
      ) : undefined}

      <Modal size="lg" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <IcClipboard style={{ marginRight: 8, color: "#3b82f6" }} />
          {idEdit ? "Editar Cliente" : "Nuevo Cliente"}
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={6}>
              <Label>Nombre</Label>
              <Input type="text" value={form.nombre_comercial} required onChange={set("nombre_comercial")} />
            </Col>
            <Col md={6}>
              <Label>Contacto</Label>
              <Input type="text" value={form.contacto} onChange={set("contacto")} />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={6}>
              <Label>Teléfono</Label>
              <Input type="text" value={form.telefono} onChange={set("telefono")} />
            </Col>
            <Col md={6}>
              <Label>Email</Label>
              <Input type="text" value={form.email} onChange={set("email")} />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={12}>
              <Label>Observaciones</Label>
              <Input type="text" value={form.observaciones} onChange={set("observaciones")} />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={guardar} disabled={!validaBoton}>Guardar</Button>
          <Button color="secondary" onClick={toggle}>Cancelar</Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoClientes;
